import { useEffect, useState } from 'react';

import { Router } from 'next/router';

import type CapacityType from '../../types/CapacityType';
import type CategoryType from '../../types/CategoryType';
import CapacityFilter from './CapacityFilter';
import CategoriesList from './CategoriesList';
import QueryFilter from './QueryFilter';

import styles from './CatalogSidebar.module.scss';

interface Props {
  categories: Array<CategoryType>;
  selectedCategory?: CategoryType;
  capacities: Array<CapacityType>;
  selectedCapacity: CapacityType | null;
  urlPrefix?: string;
}

const CatalogSidebar: React.FC<Props> = ({
  categories,
  selectedCategory,
  capacities,
  selectedCapacity,
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const closeSidebar: () => void = () => setSidebarOpen(false);

    Router.events.on('routeChangeComplete', closeSidebar);

    return () => {
      Router.events.off('routeChangeComplete', closeSidebar);
    };
  }, []);

  return (
    <div>
      <div
        className={[
          styles.catalogSidebar,
          sidebarOpen && styles.catalogSidebarOpen,
        ].join(' ')}
      >
        <QueryFilter />
        <CategoriesList
          categories={categories}
          selectedCategory={selectedCategory}
        />
        <CapacityFilter
          capacities={capacities}
          selectedCapacity={selectedCapacity}
          urlPrefix={
            selectedCategory ? `/katalog/${selectedCategory?.slug}` : `/katalog`
          }
        />
      </div>
      <div
        className={styles.catalogSidebarOverlay}
        onClick={() => setSidebarOpen(false)}
      />
      <div className={styles.sidebarButton}>
        <button onClick={() => setSidebarOpen(true)}>Filtruj wyniki</button>
      </div>
    </div>
  );
};
export default CatalogSidebar;
